export default __webpack_public_path__ + "static/media/404.430a1354.png";